export default "__VITE_ASSET__0ZiF$XOp__"